/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} British_EnglishInputs */

const en_british_english = /** @type {(inputs: British_EnglishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`British English`)
};

const fr_british_english = /** @type {(inputs: British_EnglishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anglais britannique`)
};

const de_british_english = /** @type {(inputs: British_EnglishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Britisches Englisch`)
};

const it_british_english = /** @type {(inputs: British_EnglishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inglese britannico`)
};

const ru_british_english = /** @type {(inputs: British_EnglishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Британский английский`)
};

const es_british_english = /** @type {(inputs: British_EnglishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inglés británico`)
};

const zh_cn2_british_english = /** @type {(inputs: British_EnglishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`英国英语`)
};

const ja_british_english = /** @type {(inputs: British_EnglishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イギリス英語`)
};

const hi_british_english = /** @type {(inputs: British_EnglishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ब्रिटिश अंग्रेज़ी`)
};

const pt_pt2_british_english = /** @type {(inputs: British_EnglishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inglês britânico`)
};

/**
* | output |
* | --- |
* | "British English" |
*
* @param {British_EnglishInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const british_english = /** @type {((inputs?: British_EnglishInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<British_EnglishInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_british_english(inputs)
	if (locale === "de") return de_british_english(inputs)
	if (locale === "it") return it_british_english(inputs)
	if (locale === "ru") return ru_british_english(inputs)
	if (locale === "es") return es_british_english(inputs)
	if (locale === "zh-CN") return zh_cn2_british_english(inputs)
	if (locale === "ja") return ja_british_english(inputs)
	if (locale === "hi") return hi_british_english(inputs)
	if (locale === "pt-PT") return pt_pt2_british_english(inputs)
	return en_british_english(inputs)
});